import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { IssueDetailsViewTopBar } from "./TopBar"

export const issueDetailsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: IssueDetailsViewTopBar,
}
